import { useNavigate } from "react-router-dom";
import { BOT_1, BOT_2, BOT_3, TOKEN } from "./Constants/constants";
import { useContext } from "react";
import { AppContext } from "./Context/Context";
import Logo from './images/pa3.png'

export default function Home({ setBotUrl }) {
    const navigate = useNavigate();
    const { setChatId, setBotHistory } = useContext(AppContext)

    const openChat = () => {
        if (TOKEN) {
            localStorage.setItem("BOT", 'wss://auditaibot.soof.uz/ws/audit')
            setBotHistory('xas')
            localStorage.setItem('chatbot', 'xas')
            setChatId(0)
            navigate('/chat')
            // window.location.reload()
        } else {
            navigate('/login')
        }
    };

    const handleOpenChat = () => {
        if (TOKEN) {
            localStorage.setItem('BOT', "wss://auditaibot.soof.uz/ws/mhxs")
            setBotHistory('mhxs')
            localStorage.setItem('chatbot', 'mhxs')
            setChatId(0)
            navigate('/chat')
            // window.location.reload()
        } else {
            navigate('/login')
        }
    };

    const openChat2 = () => {
        if (TOKEN) {
            localStorage.setItem("BOT", "wss://auditaibot.soof.uz/ws/soliq")
            setBotHistory('soliq')
            localStorage.setItem('chatbot', 'soliq')
            setChatId(0)
            navigate('/chat')
            // window.location.reload()
        } else {
            navigate('/login')
        }
    };

    const openChat3 = () => {
        if (TOKEN) {
            localStorage.setItem("BOT", "wss://auditaibot.soof.uz/ws/gt1")
            setBotHistory('gt1')
            localStorage.setItem('chatbot', 'gt1')
            setChatId(0)
            navigate('/chat')
            // window.location.reload()
        } else {
            navigate('/login')
        }
    };

    const openChat4 = () => {
        if (TOKEN) {
            localStorage.setItem("BOT", "wss://auditaibot.soof.uz/ws/gt2")
            setBotHistory('gt2')
            localStorage.setItem('chatbot', 'gt2')
            setChatId(0)
            navigate('/chat')
            // window.location.reload()
        } else {
            navigate('/login')
        }
    };

    const loginBtn = () => {
        if (!TOKEN) {
            navigate('/login')
        } else {
            localStorage.clear()
            window.location.reload()
        }
    }

    return (
        <div className="home-body">
            <div>
                <div className="background"></div>

                <header>
                    <div className="header-content">
                        <div className="logo" style={{ position: "relative", zIndex: 10 }}>
                            <img style={{width: "200px"}} src={Logo} alt="" />  
        
                        </div>

                        <nav className="nav-menu">
                            <button
                                className="btn btn-primary"
                                onClick={loginBtn}
                            >
                                {TOKEN ? "Log out" : "Login"}
                            </button>
                        </nav>
                    </div>
                </header>

                <main>
                    <section className="hero-section" id="home">
                        <h1 className="hero-title">MSFO Assistant</h1>
                        <p className="hero-subtitle">
                           International Financial Reporting Standards (IFRS) are becoming increasingly important in today's global business environment. This resource is designed to help you understand the standards, principles, and application of IFRS in a simple and clear way. The goal is to present the complex IFRS framework in a way that is easy to understand and understandable.
                        </p>
                        <div className="cta-buttons">
                            {/* Smooth scroll uchun oddiy <a> emas, react scroll kutubxona ishlatsa bo‘ladi */}
                            <a onClick={handleOpenChat} className="btn btn-primary">
                                <i className="fas fa-play"></i> Getting Started
                            </a>
                        </div>
                    </section>

                    <section className="features-section" id="features">
                        <div className="features-grid">
                            {/* 1-card */}
                            
                            {/* <div style={{ cursor: 'pointer', width: "30%", }} onClick={openChat3}>
                                <div
                                    className="feature-card"
                                    onMouseEnter={(e) =>
                                    (e.currentTarget.style.transform =
                                        "translateY(-15px) scale(1.02)")
                                    }
                                    onMouseLeave={(e) =>
                                        (e.currentTarget.style.transform = "translateY(0) scale(1)")
                                    }
                                >
                                    <h3>GT 1</h3>
                                    <p>
                                        Write down your questions about Grant Thornton and it will answer them.
                                    </p>
                                </div>

                            </div> */}
                            {/* <div className="feature-card-container" onClick={openChat3}>
                                <div
                                    className="feature-card"
                                    onMouseEnter={(e) =>
                                    (e.currentTarget.style.transform =
                                        "translateY(-15px) scale(1.02)")
                                    }
                                    onMouseLeave={(e) =>
                                        (e.currentTarget.style.transform = "translateY(0) scale(1)")
                                    }
                                >
                                    <h3>GT 1</h3>
                                    <p>
                                       Write down your questions about Grant Thornton and it will answer them.
                                    </p>
                                </div>

                            </div> */}
                        </div>
                    </section>
                </main>

                <footer>
                    <p>
                        &copy; 2024 Grant Thornton Uzbekistan. МСФО Ассистент - Professional
                        Financial Standards Support
                    </p>
                </footer>
            </div>
        </div>
    );
}
